import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';

const InfoContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 20px;
  background-color: var(--accent-tint);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  margin-bottom: 24px;
  max-width: 700px;
`;

const InfoIcon = styled.div`
  flex-shrink: 0;
  color: var(--accent-ink);
`;

const InfoBody = styled.div`
  flex: 1;
`;

const InfoTitle = styled.h4`
  font-family: 'IBM Plex Mono', monospace;
  font-size: 13px;
  font-weight: 600;
  color: var(--accent-ink);
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const InfoContent = styled.div`
  font-size: 14px;
  color: var(--ink-soft);
  line-height: 1.6;

  p {
    margin: 0;
  }

  code {
    font-family: 'IBM Plex Mono', monospace;
    background-color: var(--white);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 13px;
  }
`;

const InfoBlock = ({ title, children, icon = 'lightbulb' }) => {
  return (
    <InfoContainer>
      <InfoIcon><Icon name={icon} size={22} strokeWidth={1.5} /></InfoIcon>
      <InfoBody>
        {title && <InfoTitle>{title}</InfoTitle>}
        <InfoContent>{children}</InfoContent>
      </InfoBody>
    </InfoContainer>
  );
};

export default InfoBlock;